import React from 'react';
import './About.css';

// 🔗 PLACEHOLDER: Replace image src with your actual photo path or URL
const PROFILE_IMAGE_SRC = '../images/about us.jpeg'; // Set to your image path to show photo

// You can adjust this value to control where the image focuses
const IMAGE_FOCUS_POSITION = 'center 20%'; // Adjusted to show face completely

const ABOUT_DATA = {
  yearsExperience: '5',
  projectsCompleted: '200',
  happyClients: '150',
  heading: 'Welcome to Faheem Graphics – Your Destination for Creative & Design Services.',
  paragraphs: [
    {
      prefix: 'I have ',
      boldText: '5+ years of experience',
      suffix: ' in Graphic Design, UI/UX, and Animation, delivering high-quality and professional design solutions.'
    },
    {
      text: 'A passion for creativity drives everything I do. I love bringing ideas to life through designs, illustrations, and animations that communicate and inspire. Every project is a new opportunity to create something unique and impactful.'
    }
  ],
};

export default function About() {
  return (
    <section className="about section" id='about'>
      <div className="container about-container">
        <div className="about-grid">
          {/* Left column: image */}
          <div className="about-image-wrap">
            {PROFILE_IMAGE_SRC ? (
              <img
                src={PROFILE_IMAGE_SRC}
                alt="Faheem Graphics - Creative Designer"
                className="about-image"
                style={{ objectPosition: IMAGE_FOCUS_POSITION }}
              />
            ) : (
              <div className="about-image-placeholder">
                <span>👤</span>
                <p>Add your profile photo</p>
              </div>
            )}
            <div className="about-watermark" aria-hidden="true">FAHEEM</div>
          </div>

          {/* Right column: text & stats */}
          <div className="about-text">
            <span className="section-label">ABOUT ME</span>
            <h2 className="section-title">{ABOUT_DATA.heading}</h2>
            <div className="about-paragraphs">
              <p className="about-paragraph">
                <strong>{ABOUT_DATA.paragraphs[0].prefix}</strong>
                <strong>{ABOUT_DATA.paragraphs[0].boldText}</strong>
                <strong>{ABOUT_DATA.paragraphs[0].suffix}</strong>
              </p>
              <p className="about-paragraph">{ABOUT_DATA.paragraphs[1].text}</p>
            </div>

            <div className="about-stats">
               <div className="stat-item">
                <div className="stat-number">{ABOUT_DATA.yearsExperience}<span>+</span></div>
                <div className="stat-label">YEARS</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{ABOUT_DATA.projectsCompleted}<span>+</span></div>
                <div className="stat-label">PROJECTS COMPLETED</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{ABOUT_DATA.happyClients}<span>+</span></div>
                <div className="stat-label">HAPPY CLIENTS</div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}